<template>
    <v-app class="gray lighten-4">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="fullPage">

        </loading>
        <template v-if="!overlay">
            <Navbar/>
            <v-content class="py-sm-3 pr-sm-3">
                <router-view></router-view>
            </v-content>
            <div class="fb-messenger">
                <a :href="messenger" target="_blank" style="text-decoration: none">
                    <v-icon color="blue" large class="icon-mes">mdi-facebook-messenger</v-icon><br />
                </a>
                <a :href="ticket" class="ticket" target="_blank">
                    <span class="h6 font-bold">
                        <v-icon color="blue" large class="icon-mes">mdi-account-question</v-icon> Gửi Yêu Cầu Hỗ Trợ 
                    </span>
                </a>
            </div>
        </template>
        <v-overlay :value="overlay">
            <v-card class="white--text text-center" color="warning" outlined>
                <Maintain />
            </v-card>
        </v-overlay>
    </v-app>
</template>

<script>
    import Navbar from "~/components/Navbar";
    import {IS_MAINTAIN} from "~/config";
    import Maintain from "~/components/Maintain";
    import {AUTH_USER} from "~/store/actions.type";
    import {CONFIG_PAGE} from "../../store/actions.type";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        components: {
            Navbar,
            Maintain,
            Loading
        },
        data() {
            return {
                overlay: IS_MAINTAIN,
                messenger: 'https://www.facebook.com/messages/t/amaiagency',
                ticket: '/ticket/list',
                fullPage: true,
                isLoading: false
            }
        },
        computed: {},
        props: {
            source: String
        },
        created() {
            this.checkValidToken();
              this.$store.watch(
                state => state.common.isLoading,
                () => {
                  this.isLoading = this.$store.state.common.isLoading;
                }
              );
        },
        methods: {
            logout() {
                this.$store.dispatch("auth_logout");
                this.$router.push("/login");
            },
            async checkValidToken() {
                let result = await this.$store.dispatch(AUTH_USER);
                if (result === false) {
                    this.logout();
                }
                if(!result.success){
                    this.overlay = true;
                }
            },
            async configPage(){
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let messenger = data.filter(o => o.key == 'key_cp_messenger');
                    if(messenger[0]['value'] != undefined && messenger[0]['value'] != ''){
                        this.messenger = messenger[0]['value'];
                    }
                });
            },
        },
        mounted() {
            this.configPage();
        }
    };
</script>
<style lang="scss">
    @import "../../scss/main";
    .v-content {
        background-color: $mainColor;
        .v-content__wrap {
            background-color: $bgMainColor;
            border-radius: 15px;
        }
        @media (min-width: 600px) {
            .v-content__wrap {
                margin-left: 12px !important;
            }
        }
    }
    .fb-messenger {
        position: fixed;
        bottom: 40px;
        right: 18px;
        cursor: pointer;
    }
    .icon-mes {
        font-size: 64px !important;
        font-weight: bold;
    }
    .icon-mes:hover {
        font-size: 72px !important;
    }
    .text_notes {
        text-align: justify;
    }

    div.explain {
        padding-bottom: 30px;
        background: none !important;
    }
    div.explain span {
        font-weight: 500;
        font-size: 15px;
    }
    div.explain span.red_text {
        color: red;
    }
    div.explain span.blue_text {
        color: blue;
        text-decoration: underline;
        font-style: italic;
    }
    .maintain_notice{
        position: absolute;
        height: 50px;
        top: 50%;
        left: 40%;
    }

    div.menus .v-list-item__action:first-child,
    div.menus .v-list-item__icon:first-child {
        margin-right: 10px;
        margin-left: 0px !important;
    }

    div.menus i.v-icon {
        font-size: 18px !important;
    }

    div.menus span.buy_ip_hot {
        position: absolute;
        right: 1rem;
        color: #fff;
        background-color: #dc3545;
        display: inline-block;
        padding: .25em .4em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        margin-right: 20px;
    }
    div.menus div.v-list-group__items {
        border-left: 3px solid rgb(255, 160, 0);
    }
    div.menus div.v-list-group__items div.v-list-item__icon{
        margin-left: -3px !important;
    }
    div.menus .theme--light.v-list-item--active {
        background-color: rgba(255,255,255,.1);
    }

    .label-highlight {
        color: red;
        animation-name: hightlight;
        animation-duration: 0.8s;
        animation-iteration-count: infinite;
    }

    .fb-messenger a.ticket {
        text-decoration: none;
        background-color: #df043e;
        padding: 10px 30px;
        color: #fff!important;
        border-radius: 20px 20px 0 0;
        position: fixed;
        cursor: pointer;
        bottom: 0;
        right: 15px;
        height: 40px;
        font-size: 15px;
        z-index: 1000;
        border-bottom: 0;
        text-decoration: none
    }

    .fb-messenger a.ticket i {
        font-weight: 400;
        vertical-align: middle;
        font-family: "Font Awesome 5 Free";
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
        font-size: 1.2rem !important;
        color: #fff !important;
        margin-top: -6px;
        margin-right: 5px;
    }


    @keyframes hightlight {
        0%   {color: red;}
        50%  {color: blue;}
        100% {color: green;}
    }
</style>
